import lodashGet from 'lodash/get';
import isNull from 'lodash/isNull';

export const get = (object, path, defaultValue) => {
  const value = lodashGet(object, path, defaultValue);

  return isNull(value) ? defaultValue : value;
};
